"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CW_TUTOR_TEMPLATES = exports.CW_TUTOR_TEMPLATES_MD = void 0;
exports.CW_TUTOR_TEMPLATES_MD = {
    'ACT Prep (All Sections/Introduction)': `* Overview of the exam’s structure and scoring scales\n
* Review of previous homework assignment\n
* Introduce new content from a core section of the exam\n
* Plan for our next session together`,
    'ACT Prep (English)': `* Walk through specific rules within the English (grammar) section of the test\n
* Understand how best to approach the material\n
* Create a homework assignment for the week ahead`,
    'ACT Prep (Math)': `* Walk through specific mathematics subjects found within the Math section of the test\n
* Learn the particular formulas, properties, and rules that apply therein.\n
* Learn strategies to apply particular methods, approaches, or tricks to problem solving\n
* Create a homework assignment for the week ahead`,
    'ACT Prep (Reading)': `* Walk through the structure and stylization of the Reading section of the test\n
* Understand different approaches to the Reading section and how best to navigate that body of work.\n
* Better differentiate among the section’s different question and answer types\n
* Create a homework assignment for the week ahead`,
    'ACT Prep (Science)': `* Walk through the structure and stylization of the Science section of the test\n
* Understand different approaches to the Science section and how best to navigate that body of work.\n
* Better differentiate among the section’s different question and answer types\n
* Create a homework assignment for the week ahead`,
    'SAT Prep (All Sections/Introduction)': `* Overview of the exam’s structure and scoring scales\n
* Review of previous homework assignment\n
* Introduce new content from a core section of the exam\n
* Plan for our next session together`,
    'SAT Prep (Reading/Writing)': `* Walk through the structure and stylization of the Reading/Writing section of the test and its varied question types\n
* Understand different approaches to the Reading section and how best to navigate that body of work.\n
* Better differentiate among the section’s different question and answer types\n
* Create a homework assignment for the week ahead`,
    'SAT Prep (Math)': `* Walk through specific mathematics subjects found within the Math section of the test\n
* Learn the particular formulas, properties, and rules that apply therein.\n
* Learn strategies to apply particular methods, approaches, or tricks to problem solving\n
* Create a homework assignment for the week ahead`,
    'Academic/Curricular Tutoring': `* Overview of recent work from class\n
* Dive into recent assignments\n
* Prepare for upcoming work in class\n
* Plan for next meeting`,
    'Leadership Academy Session': `* Navigate this week’s session of the Leadership Academy curriculum\n
* Put together a plan for the next session`,
    'Success Skills Session': `* Navigate this week’s session of the Success Skills curriculum\n
* Put together a plan for the next session`,
};
const convertCWTemplates = (source) => {
    const result = {};
    for (const key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            const contentLines = source[key].split('\n').filter((line) => line.trim() !== '');
            const convertedContent = contentLines.map((line, index) => ({
                listStart: index + 1,
                type: 'p',
                children: [{ text: line.replace('*', '').trim() }],
                listStyleType: 'disc',
                indent: 1,
            }));
            result[key] = convertedContent;
        }
    }
    return result;
};
exports.CW_TUTOR_TEMPLATES = convertCWTemplates(exports.CW_TUTOR_TEMPLATES_MD);
//# sourceMappingURL=cw-tutor.js.map